export type Tone = "neutral" | "brand" | "success" | "warning" | "danger";
export type MessageState = "ACCEPTED" | "ROUTED" | "SUBMITTED" | "DELIVERED" | "FAILED";
export type ChannelState = "healthy" | "degraded" | "open" | "removed" | "disabled";

export interface StateMeta { tone: Tone; label: string }

/** 消息状态到胶囊色调与中文标签的映射，页面不自行选色。 */
export const MESSAGE_STATE: Record<MessageState, StateMeta> = {
  ACCEPTED: { tone: "neutral", label: "已接收" },
  ROUTED: { tone: "neutral", label: "已路由" },
  SUBMITTED: { tone: "brand", label: "已提交" },
  DELIVERED: { tone: "success", label: "已送达" },
  FAILED: { tone: "danger", label: "失败" },
};

export const CHANNEL_STATE: Record<ChannelState, StateMeta> = {
  healthy: { tone: "success", label: "健康" },
  degraded: { tone: "warning", label: "降级" },
  open: { tone: "danger", label: "熔断" },
  removed: { tone: "neutral", label: "已摘除" },
  disabled: { tone: "neutral", label: "停用" },
};
